import { AddIcon, ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Collapse,
  Heading,
  IconButton,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import GptToggleButton from "../../../Common/GptToggleButton";
import { CaseProConditionRules } from "../CaseProConditonRules";
import { CaseProRulesItem } from "../CaseProRulesItem";

const CaseProRulesType = ({
  type,
  control,
  path,
  rule,
  trueSteps,
  falseSteps,
  addTrueStep,
  removeTrueStep,
  addFalseStep,
  removeFalseStep,
}) => {
  const { isOpen, onToggle } = useDisclosure();

  if (type !== "RULE") return null;

  return (
    <>
      {/* CONDITION */}
      <Box mt={4} borderLeft="3px solid" borderColor="blue.100" pl={3}>
        <Box
          as="button"
          width="100%"
          px={4}
          py={3}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          fontWeight="semibold"
          borderRadius="md"
          bg="#F7FAFC"
          _hover={{ bg: "gray.100" }}
          onClick={onToggle}
        >
          <Box textAlign="left">
            {" "}
            <Heading size="xs">Condition</Heading>
          </Box>

          <Box
            transform={isOpen ? "rotate(180deg)" : "rotate(0deg)"}
            transition="transform 0.2s ease"
          >
            <ChevronDownIcon />
          </Box>
        </Box>
        {/* <Button
          size="xs"
          onClick={onToggle}
          rightIcon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
        >
          Condition
        </Button> */}

        <Collapse in={isOpen} animateOpacity>
          <Box mt={2}>
            <CaseProConditionRules
              control={control}
              register={() => {}}
              path={`${path}.CONDITION`}
              groupData={
                rule.CONDITION ?? {
                  Field: "",
                  Operator: "==",
                  Value: "",
                }
              }
            />
          </Box>
        </Collapse>
      </Box>

      {/* TRUE STEP */}
      <NestedStep
        title="TRUE_STEP"
        control={control}
        path={`${path}.TRUE_STEP`}
        steps={trueSteps}
        addStep={addTrueStep}
        removeStep={removeTrueStep}
      />

      {/* FALSE STEP */}
      <NestedStep
        title="FALSE_STEP"
        control={control}
        path={`${path}.FALSE_STEP`}
        steps={falseSteps}
        addStep={addFalseStep}
        removeStep={removeFalseStep}
      />
    </>
  );
};

export default CaseProRulesType;
// Nested steps helper
const NestedStep = ({ title, steps, addStep, removeStep, path, control }) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });

  return (
    <Box
      mt={4}
      pl={3}
      borderLeft="4px solid"
      borderColor={title === "TRUE_STEP" ? "green.300" : "red.300"}
    >
      <Stack direction="row" align="center" justify="space-between" w="100%">
        <GptToggleButton title={title} isOpen={isOpen} onToggle={onToggle} />
        <IconButton
          size="sm"
          color={title === "TRUE_STEP" ? "green.300" : "red.300"}
          cursor="pointer"
          borderRadius="full"
          onClick={() =>
            addStep({
              TYPE: "RULE",
              ID: `RULE_${Date.now()}`,
              CONDITION: { Field: "", Operator: "==", Value: "" },
              TRUE_STEP: [],
              FALSE_STEP: [],
            })
          }
          icon={<AddIcon />}
        />
      </Stack>
      <Collapse in={isOpen} animateOpacity>
        <Stack spacing={3} mt={3}>
          {steps.map((step, j) => (
            <CaseProRulesItem
              key={step.id || `${title}-${j}`}
              control={control}
              path={`${path}.${j}`}
              rule={step}
              remove={() => removeStep(j)}
              depth={1}
            />
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
};
